import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionSubType } from "../../../Pages/QuestionSubType/IQuestionSubType";

export const EditQuestionSubTypeSlice = createSlice({
  name: "EditQuestionSubTypeSlice",
  initialState: {} as IReduxState<IQuestionSubType>,
  reducers: {
    EditQuestionSubType: (state, _: PayloadAction<IQuestionSubType>) => {
      state.isLoading = true;
    },
    successEditQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditQuestionSubTypeResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditQuestionSubType,
  failureEditQuestionSubType,
  successEditQuestionSubType,
  clearEditQuestionSubTypeResponse,
} = EditQuestionSubTypeSlice.actions;

export default EditQuestionSubTypeSlice.reducer;
